export const record_point_latlng = (key, { lat, lng }) => {
    return {
        [key]: { lat, lng }
    }
} 

export const bind_table_sign_tooltip  = (marker, alert_content, item_num) => {
    if (!alert_content[item_num]) {
        return marker.bindTooltip(
            `
                ${item_num}
                -
            `, 
            { 
                className: 'monitor-table-tooltip' ,
                direction: 'top',
            }
        )
    }
    const { icon_class, signal_class } = alert_content[item_num]
    const html = `<i class="v-icon ${icon_class} ${signal_class}"></i>`
    marker.bindTooltip(
        `
        ${item_num}
        ${html}
        `, 
        { 
            className: 'monitor-table-tooltip' ,
            direction: 'top',
        }
    )
}